import { useLocation, Link, useParams } from 'react-router-dom';
import { Activity, Users, Calendar } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/utils';

const tabs = [
  { label: 'Activities', icon: Activity, value: 'activities' },
  { label: 'Tenants', icon: Users, value: 'tenants' },
  { label: 'Bookings', icon: Calendar, value: 'bookings' }
];

const Navigation = () => {
  const location = useLocation();
  const { id } = useParams();
  const pathParts = location.pathname.split('/');
  const activeTab = pathParts.length > 3 ? pathParts[3] : 'activities';

  return (
    <div className="flex items-center gap-2 px-4 py-2 border-y bg-muted">
      {tabs.map((tab) => {
        const IconComponent = tab.icon;
        const isActive = tab.value === activeTab;
        return (
          <Button
            key={tab.value}
            size="sm"
            variant={isActive ? 'outline' : 'ghost'}
            asChild
            className={cn('border', !isActive && 'border-transparent')}
          >
            <Link
              to={`/coach/${id}${
                tab.value !== 'activities' ? `/${tab.value}` : ''
              }${location.search}`}
            >
              <IconComponent className="w-4 h-4" />
              {tab.label}
            </Link>
          </Button>
        );
      })}
    </div>
  );
};

export default Navigation;
